import React, { useEffect, useState, useCallback } from "react";
import {
  Modal,
  Box,
  Button,
  TextField,
  Typography,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { getAlldeliveryPersonnel } from "../../api/Api";
import { useTheme } from "@mui/material/styles";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70vw",
  bgcolor: "background.paper",
  borderRadius: 1,
  boxShadow: "none",
};

const BulkorderDetails = ({ open, onClose, orderData, handleUpdateOrder }) => {
  const theme = useTheme();
  const [updatedData, setUpdatedData] = useState({
    order_id: "",
    total_amount: "",
    payment_status: "",
    delivery_person: "",
    delivery_status: "",
  });

  const [personnel, setPersonnel] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchDeliveryPersonnel = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getAlldeliveryPersonnel();
      const deliveryPersonnel = response.data.data;
      setPersonnel(deliveryPersonnel);
    } catch (error) {
      console.error("Error fetching delivery personnel:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDeliveryPersonnel();
  }, [fetchDeliveryPersonnel]);

  useEffect(() => {
    if (orderData) {
      setUpdatedData({
        order_id: orderData._id || "",
        total_amount: orderData.totalAmount || "",
        payment_status: orderData.paymentStatus || "",
        delivery_person: orderData.delivery_person || "",
        delivery_status: orderData.deliveryStatus || "",
      });
    }
  }, [orderData]);

  const handleChange = (e) => {
    setUpdatedData({
      ...updatedData,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = (e) => {
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
      }}
    >
      <Box sx={style} component="form">
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            padding: "10px",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography id="update-item-modal-title" variant="h6" component="h2">
            Verify Order Details
          </Typography>
          <Button
            onClick={onClose}
            style={{ color: "#fff", fontSize: "1.2rem" }}
          >
            ✖
          </Button>
        </Box>

        <Box sx={{ padding: "20px" }}>
          <Grid container spacing={2}>
            {/* First Row */}
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Order ID"
                name="order_id"
                value={updatedData.order_id}
                variant="outlined"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Total Amount"
                name="total_amount"
                value={updatedData.total_amount}
                variant="outlined"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Payment Status"
                name="payment_status"
                value={updatedData.payment_status}
                variant="outlined"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={2}>
              <Button
                variant="contained"
                sx={{
                  padding: "13px",
                  backgroundColor: theme.palette.primary.light,
                  textTransform: "capitalize",
                  width: "50%",
                }}
                fullWidth
                onClick={() => console.log("Verification Triggered")}
              >
                Verify Now
              </Button>
            </Grid>

            {/* Second Row */}
            <Grid item xs={3}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Assign Delivery Person</InputLabel>
                <Select
                  label="Assign Delivery Person"
                  name="delivery_person"
                  value={updatedData.delivery_person}
                  onChange={handleChange}
                >
                  {personnel.map((person) => (
                    <MenuItem key={person._id} value={person.name}>
                      {person.name} ({person.area})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Delivery Status</InputLabel>
                <Select
                  label="Delivery Status"
                  name="delivery_status"
                  value={updatedData.delivery_status}
                  onChange={handleChange}
                >
                  <MenuItem value="Pending">Pending</MenuItem>
                  <MenuItem value="Dispatched">Dispatched</MenuItem>
                  <MenuItem value="In Transit">In Transit</MenuItem>
                  <MenuItem value="Delivered">Delivered</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Third Row */}
            <Grid item xs={12} sx={{ textAlign: "right" }}>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  width: "160px",
                  backgroundColor: theme.palette.primary.light,
                  textTransform: "capitalize",
                  padding: "12px",
                }}
              >
                Update Data
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
};

export default BulkorderDetails;
